import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '../../assets/images/info.svg'
import _imports_1 from '@/assets/images/copy.png'


const _hoisted_1 = { class: "px-5 pb-5 container" }
const _hoisted_2 = { class: "tutorial-rustdesk-title" }
const _hoisted_3 = { class: "exclusive-version-card mt-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "info"
}, null, -1)
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "tutorial-rustdesk mt-4" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "download-options" }
const _hoisted_9 = { class: "windows" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Windows:", -1)
const _hoisted_11 = { class: "linux" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Linux:", -1)
const _hoisted_13 = { class: "tutorial-rustdesk mt-4" }
const _hoisted_14 = { class: "mt-2" }
const _hoisted_15 = { class: "config" }
const _hoisted_16 = { class: "config-card" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Local")
], -1)
const _hoisted_18 = { class: "mt-2" }
const _hoisted_19 = {
  key: 0,
  class: "button-copy",
  title: "copiar texto"
}
const _hoisted_20 = { class: "card-tutorial-rustdesk" }
const _hoisted_21 = ["src", "alt"]
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "tutorial-rustdesk mt-4" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "mt-2" }
const _hoisted_26 = { class: "card-tutorial-rustdesk" }
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "credentials" }
const _hoisted_30 = { class: "credentials-card" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "RustDesk")
], -1)
const _hoisted_32 = { class: "mt-2" }
const _hoisted_33 = {
  key: 0,
  class: "button-copy",
  title: "copiar texto"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "copiar texto"
}, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "credentials-card" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Mac")
], -1)
const _hoisted_38 = { class: "mt-2" }
const _hoisted_39 = { class: "tutorial-rustdesk other-recomendations mt-5" }
const _hoisted_40 = { class: "tutorial-list mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ds_button = _resolveComponent("ds-button")!
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("tutorialRustDesk.accessMac")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("tutorialRustDesk.subtitle")), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("p", {
        innerHTML: _ctx.$t('tutorialRustDesk.first.exclusiveVersion')
      }, null, 8, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h6", null, _toDisplayString(_ctx.$t("tutorialRustDesk.first.title")), 1),
      _createElementVNode("p", {
        innerHTML: _ctx.texts.firstPoint
      }, null, 8, _hoisted_7),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_ds_button, {
            type: "secondary",
            text: _ctx.$t('tutorialRustDesk.buttons.installRustDesk'),
            leftIcon: "open_in_new",
            onClick: _ctx.openInstallRustDeskForWindows
          }, null, 8, ["text", "onClick"])
        ]),
        _createElementVNode("span", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_ds_button, {
            type: "secondary",
            text: _ctx.$t('tutorialRustDesk.buttons.installRustDesk'),
            leftIcon: "open_in_new",
            onClick: _ctx.openInstallRustDeskForLinux
          }, null, 8, ["text", "onClick"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("h6", null, _toDisplayString(_ctx.$t("tutorialRustDesk.config.title")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("tutorialRustDesk.config.subtitle")), 1),
      _createVNode(_component_ds_button, {
        type: "secondary",
        leftIcon: "open_in_new",
        onClick: _ctx.showModalForConfigRustDesk,
        text: _ctx.$t('tutorialRustDesk.config.textToOpenModal')
      }, null, 8, ["onClick", "text"]),
      _createElementVNode("h6", _hoisted_14, _toDisplayString(_ctx.$t("tutorialRustDesk.config.secondTitle")), 1),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("p", _hoisted_18, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("tutorialRustDesk.config.localId")), 1),
            _createTextVNode(_toDisplayString(_ctx.credentials.userLocalId) + " ", 1),
            (_ctx.credentials.complete)
              ? (_openBlock(), _createElementBlock("button", _hoisted_19, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "copiar texto",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyText(_ctx.credentials.userLocalId)))
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_Dialog, {
            visible: _ctx.showModalConfigRustDesk,
            "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showModalConfigRustDesk) = $event)),
            modal: ""
          }, {
            header: _withCtx(() => [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('tutorialRustDesk.config.titleModal')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Carousel, {
                value: _ctx.screenShots,
                numVisible: 1,
                numScroll: 1
              }, {
                item: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("img", {
                      src: require(`@/assets/images/${slotProps.data.path}`),
                      alt: slotProps.data.description,
                      class: "img-tutorial-rustdesk"
                    }, null, 8, _hoisted_21),
                    _createElementVNode("p", {
                      innerHTML: slotProps.data.description
                    }, null, 8, _hoisted_22)
                  ])
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 8, ["visible"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("h6", null, _toDisplayString(_ctx.$t("tutorialRustDesk.credentials.title")), 1),
      _createElementVNode("p", {
        innerHTML: _ctx.texts.subtitle
      }, null, 8, _hoisted_24),
      _createElementVNode("h6", _hoisted_25, _toDisplayString(_ctx.$t("tutorialRustDesk.credentials.secondTitle")), 1),
      _createVNode(_component_ds_button, {
        type: "secondary",
        leftIcon: "open_in_new",
        onClick: _ctx.showModalForInitializeRustDesk,
        text: _ctx.$t('tutorialRustDesk.credentials.textToOpenModal')
      }, null, 8, ["onClick", "text"]),
      _createVNode(_component_Dialog, {
        visible: _ctx.showModalInializationRustDesk,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showModalInializationRustDesk) = $event)),
        modal: ""
      }, {
        header: _withCtx(() => [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('tutorialRustDesk.credentials.titleModal')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Carousel, {
            value: _ctx.screenShotsInialization,
            numVisible: 1,
            numScroll: 1
          }, {
            item: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("img", {
                  src: require(`@/assets/images/${slotProps.data.path}`),
                  alt: slotProps.data.description,
                  class: "img-tutorial-rustdesk"
                }, null, 8, _hoisted_27),
                _createElementVNode("p", {
                  innerHTML: slotProps.data.description
                }, null, 8, _hoisted_28)
              ])
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("p", _hoisted_32, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("tutorialRustDesk.credentials.remoteAddress")), 1),
            _createTextVNode(_toDisplayString(_ctx.credentials.userRustDesk) + " ", 1),
            (_ctx.credentials.complete)
              ? (_openBlock(), _createElementBlock("button", _hoisted_33, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "copiar texto",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copyText(_ctx.credentials.userRustDesk)))
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("tutorialRustDesk.credentials.password")), 1),
            _createTextVNode(_toDisplayString(_ctx.credentials.passwordRustDesk) + " ", 1),
            (_ctx.credentials.complete)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button-copy",
                  title: "copiar texto",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.copyText(_ctx.credentials.passwordRustDesk)))
                }, _hoisted_35))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("p", _hoisted_38, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("tutorialRustDesk.credentials.user")), 1),
            _createTextVNode(_toDisplayString(_ctx.credentials.userMac), 1)
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("tutorialRustDesk.credentials.password")), 1),
            _createTextVNode(_toDisplayString(_ctx.credentials.passwordMac), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("h6", null, _toDisplayString(_ctx.$t("tutorialRustDesk.second.title")), 1),
      _createElementVNode("ul", _hoisted_40, [
        _createElementVNode("li", null, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("tutorialRustDesk.second.firstPoint")), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("tutorialRustDesk.second.secondPoint")), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("tutorialRustDesk.second.thirdPoint")), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("tutorialRustDesk.second.fourthPoint")), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("tutorialRustDesk.second.fifthPoint")) + " suporte@email.com", 1)
        ])
      ])
    ])
  ]))
}